export { default } from './BancoAutoFinanciePesado';
